import { ApiProperty } from '@nestjs/swagger';
import { ArrayNotEmpty, IsArray, IsUUID } from 'class-validator';

export class ReordenarProductoEspecificacionesDto {
  @ApiProperty({
    description: 'IDs de las especificaciones en el orden deseado (la primera queda con orden 0)',
    type: [String],
  })
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID(undefined, { each: true })
  ids: string[];
}
